// UI/ToggleButton/Manuell.tsx
import './toggle.css';
import React from 'react';

interface ManuellProps {
    toggle: boolean;
    handleToggleChange: () => void;
    children?: React.ReactNode; // Make children optional
}

export const automat = <span className='categoryRegist'>Manuell</span>;
export const manuell = <span className='categoryRegist'>Manuell</span>;

export const Manuell: React.FC<ManuellProps> = ({ toggle, handleToggleChange, children }) => {
    return (
        <div onClick={handleToggleChange}>
            <div className={`toggle-btn ${!toggle ? 'disable' : ''}`}>
                {toggle ? automat : manuell}
                {children} {/* Render the children here */}
            </div>
        </div>
    );
};

